module.exports = __webpack_public_path__ + "close-icon-d0828c166fdfa2776bec.svg";